import React from 'react';
import { Box, Grid } from '@material-ui/core';
import down_arrow_svg from './down_arrow.svg';

export default function DownArrow() {
  return (
    <Box
      style={{
        marginTop: '0.5rem',
        marginBottom: '0.5rem',
        height: '10px',
        width: '100%',
        backgroundImage: `url(${down_arrow_svg})`,
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
      }}
    ></Box>
  );
}
